import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type SkeletonShape = 'line' | 'title' | 'block' | 'card' | 'circle';

const SHAPES: Record<SkeletonShape, string> = {
  line: 'h-4 w-full rounded-full',
  title: 'h-9 w-2/3 rounded-xl',
  block: 'h-24 w-full rounded-2xl',
  card: 'h-72 w-full rounded-2xl',
  circle: 'size-9 rounded-full',
};

/**
 * Segnaposto di caricamento, decorativo: lo stato si annuncia con `aria-busy` sul contenitore
 * che lo ospita e con un testo per i lettori di schermo.
 */
@Component({
  selector: 'bs-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block', 'aria-hidden': 'true' },
  template: `<div [class]="classes()"></div>`,
})
export class SkeletonComponent {
  readonly shape = input<SkeletonShape>('line');
  protected readonly classes = computed(
    () => `animate-pulse bg-stone-200 dark:bg-stone-800 ${SHAPES[this.shape()]}`,
  );
}
